var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rwd-toolbar",class:[`rwd-toolbar--stack-${_vm.stackAt}`, `rwd-toolbar--align-${_vm.align}`]},[_c('div',{staticClass:"rwd-toolbar__filters"},[_vm._t("default")],2),(_vm.hasActions)?_c('div',{staticClass:"rwd-toolbar__actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }